import colors from 'styles/colors'

export const ChartOptions = {
  tooltipTemplate: '<%= value %>',
  bezierCurve: false,
  pointDotRadius: 8,
  pointDotStrokeWidth: 2,
  datasetFill: false,
  scaleShowVerticalLines: false,
  tooltipYPadding: 12,
  tooltipXPadding: 12,
  pointHitDetectionRadius: 3,
  tooltipYOffset: 20,
  tooltipFontStyle: 'bold',
  responsive: true,
  maintainAspectRatio: false,
  tooltipFontFamily: 'Brandon',
  scaleFontFamily: 'Brandon'
}

export const ColorConfig = {
  fillColor: colors['color-white'],
  strokeColor: colors['color-green'],
  pointColor: colors['color-white'],
  pointStrokeColor: colors['color-green'],
  pointHighlightFill: colors['color-green'],
  pointHighlightStroke: colors['color-green']
}



// WEBPACK FOOTER //
// ./src/scripts/constants/ChartConfig.js